'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _clickoutside = require('element-ui/lib/utils/clickoutside');

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _emitter = require('element-ui/lib/mixins/emitter');

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_VALUE = Number.MAX_VALUE;
var MIN_VALUE = 0;
var SELECT_ALL = 'selectAll';
var SELECT_INVERSE = 'selectInverse';

exports.default = {
  name: 'ElGroupSelect',
  componentName: 'ElGroupSelect',

  mixins: [_emitter2.default],
  directives: { Clickoutside: _clickoutside2.default },

  props: {
    // 选项列表（支持分组）
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 当前选中ids
    value: {
      type: Array,
      required: true
    },
    // 默认选中ids
    defaultSelected: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 选中上限数
    max: {
      type: Number,
      default: MAX_VALUE
    },
    min: {
      type: Number,
      default: MIN_VALUE
    },
    // 上限提示文案
    maxHint: {
      type: String
    },
    minHint: {
      type: String
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 是否提供 label 搜索
    filterable: {
      type: Boolean,
      default: false
    },
    filterPlaceholder: {
      type: String,
      default: '输入关键字搜索'
    },
    filterNoResult: {
      type: String,
      default: '抱歉没有找到~'
    },
    // 快捷选择（暂支持“全选”和“反选”）
    selectShortcuts: {
      type: Array,
      default: function _default() {
        return [];
      } // SELECT_ALL, SELECT_INVERSE
    },
    // close 标签后关闭 selector 主体
    hideOnCloseTag: {
      type: Boolean,
      default: true
    },
    // 恢复默认后直接触发 change
    syncOnReset: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    value: function value(val) {
      // 防止外部对 value 赋值时，组件内部对 selectedIds 的操作直接影响数组的引用
      this.selectedIds = Array.prototype.slice.call(val);
      this.dispatch('ElFormItem', 'el.form.change', val);
    },
    selectAll: function selectAll(val) {
      if (val) {
        this.selectInverse = false;
        this.currentSelectedIds = this.allItems.map(function (item) {
          return item.id;
        });
      }
    },
    selectInverse: function selectInverse(val) {
      var _this = this;

      if (val) {
        this.selectAll = false;
        this.currentSelectedIds = this.allItems.map(function (item) {
          return item.id;
        }).filter(function (id) {
          return !_this.currentSelectedIds.includes(id);
        });
      }
    }
  },

  data: function data() {
    return {
      selectedIds: Array.prototype.slice.call(this.value), // 按完“确定”后才生效
      currentSelectedIds: Array.prototype.slice.call(this.value), // checkbox 选择的状态（未“确定”前的状态）
      lastCheckLength: this.value.length, // 用于 `vue < 2.5` 时修正前一状态的选中数目
      filterInput: '', // filterable 时的输入
      selectAll: false, // 全选
      selectInverse: false, // 反选
      showMaxLimit: false,
      showMinLimit: false,
      open: false
    };
  },


  computed: {
    allItems: function allItems() {
      var items = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          if (group.children && group.children.length) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _getIterator3.default)(group.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var child = _step2.value;

                items.push(child);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else {
            items.push(group);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return items;
    },
    selectedItems: function selectedItems() {
      var items = [];
      // 以 allItem 为遍历，保持展示顺序
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(this.allItems), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          if (this.selectedIds.includes(item.id)) {
            items.push(item);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return items;
    },
    hasGroup: function hasGroup() {
      return this.data.find(function (group) {
        return !!(group.children && group.children.length);
      });
    }
  },

  methods: {
    handleCheckboxNative: function handleCheckboxNative(e) {
      var _this2 = this;

      if (!e.target || e.target.tagName !== 'INPUT') {
        return;
      }
      this.selectAll && (this.selectAll = false);
      this.selectInverse && (this.selectInverse = false);
      this.showMaxLimit = false;
      this.showMinLimit = false;
      var nativeChecked = e.target.checked;
      var preLen = this.currentSelectedIds.length;

      // NOTE: vue@2.5 后 `v-on` handler 里的 state 变化被延迟
      // see https://github.com/vuejs/vue/releases/tag/v2.5.0  Internals
      this.$nextTick(function () {
        var newLen = _this2.currentSelectedIds.length;
        // NOTE: el-checkbox-group 会限制 min max，结合 nativeChecked 用于给出超限提示
        if (nativeChecked && (preLen === newLen ? _this2.lastCheckLength === _this2.max : preLen === _this2.max)) {
          _this2.showMaxLimit = true;
          _this2.$emit('prevent-max');
        } else if (!nativeChecked && (preLen === newLen ? _this2.lastCheckLength === _this2.min : preLen === _this2.min)) {
          _this2.showMinLimit = true;
          _this2.$emit('prevent-min');
        }
        _this2.lastCheckLength = newLen;
      });
    },
    handleCloseTag: function handleCloseTag(event, item) {
      event.stopPropagation();
      if (this.selectedIds.length <= this.min) {
        event.preventDefault();
        this.$emit('prevent-close-tag');
        return false;
      }
      this.closeTag(item);
    },
    closeTag: function closeTag(item) {
      var index = this.selectedIds.indexOf(item.id);
      index > -1 && this.$delete(this.selectedIds, index);
      var curIndex = this.currentSelectedIds.indexOf(item.id);
      curIndex > -1 && this.$delete(this.currentSelectedIds, curIndex);

      // NOTE 取消标签后立即触发 onchange
      this.fireChangeEvent();
      this.hideOnCloseTag && this.close();
    },


    // 关闭选择器
    close: function close() {
      this.open && (this.open = false);
    },


    // 切换开闭
    toggleOpen: function toggleOpen() {
      this.open = !this.open;
      if (this.open) {
        // 组件 value 有可能已经在外部被修改了，同步 currentSelectedIds checkbox 状态
        this.currentSelectedIds = Array.prototype.slice.call(this.selectedIds);
        this.filterInput = '';
        // 同步主体的位置
        this.$refs.body.style.top = this.$refs.header.offsetHeight + 10 + 'px';
      }
    },


    // 恢复默认选中
    resetDefault: function resetDefault() {
      this.currentSelectedIds = Array.prototype.slice.call(this.defaultSelected);
      this.syncOnReset && this.selectDone();
      this.$emit('reset');
    },


    // 选择完成
    selectDone: function selectDone() {
      this.selectedIds = this.currentSelectedIds;
      this.fireChangeEvent();
      this.close();
    },
    fireChangeEvent: function fireChangeEvent() {
      this.$emit('input', this.selectedIds);
      this.$emit('change', this.selectedIds);
    },
    renderHeader: function renderHeader() {
      var _this3 = this;

      var h = this.$createElement;

      var headerContent = this.selectedIds.length ? h(
        'div',
        { 'class': 'selector__tags' },
        [this.selectedItems.map(function (item) {
          return h(
            'span',
            { 'class': 'el-tag el-tag--primary' },
            [item.label, h(
              'i',
              { 'class': 'el-tag__close el-icon-close',
                on: {
                  'click': function click(e) {
                    return _this3.handleCloseTag(e, item);
                  }
                }
              },
              []
            )]
          );
        })]
      ) : h(
        'span',
        { 'class': 'selector__placeholder' },
        [this.placeholder]
      );

      return h(
        'div',
        { 'class': 'selector__header', ref: 'header', on: {
            'click': this.toggleOpen
          }
        },
        [headerContent, h(
          'i',
          { 'class': ['selector__caret ', this.open ? 'el-icon-caret-top' : 'el-icon-caret-bottom'] },
          []
        )]
      );
    },
    renderShortcuts: function renderShortcuts() {
      var _this4 = this;

      var h = this.$createElement;

      if (!this.selectShortcuts || !this.selectShortcuts.length) {
        return;
      }
      var hasSelectAll = this.selectShortcuts.includes(SELECT_ALL);
      var hasSelectInverse = this.selectShortcuts.includes(SELECT_INVERSE);
      return h(
        'div',
        { 'class': 'select-shortcuts' },
        [hasSelectAll && h(
          'el-checkbox',
          {
            attrs: { value: this.selectAll },
            on: {
              'input': function input(v) {
                _this4.selectAll = v;
              }
            }
          },
          ['\u5168\u9009']
        ), hasSelectInverse && h(
          'el-checkbox',
          {
            attrs: { value: this.selectInverse },
            on: {
              'input': function input(v) {
                _this4.selectInverse = v;
              }
            }
          },
          ['\u53CD\u9009']
        )]
      );
    },
    renderCheckboxItem: function renderCheckboxItem(item, isShow) {
      var h = this.$createElement;

      return h(
        'el-checkbox',
        { key: item.id, attrs: { label: item.id
          },
          nativeOn: {
            'click': this.handleCheckboxNative
          },
          directives: [{
            name: 'show',
            value: isShow
          }]
        },
        [item.label, item.tip && h(
          'el-tooltip',
          {
            attrs: { placement: 'top', popperClass: 'el-gs__tooltip__popper' }
          },
          [h(
            'div',
            { slot: 'content', domProps: {
                'innerHTML': item.tip
              }
            },
            []
          ), h(
            'i',
            { 'class': 'el-icon-information' },
            []
          )]
        )]
      );
    },
    renderGroups: function renderGroups() {
      var _this5 = this;

      var h = this.$createElement;

      var query = (this.filterInput || '').trim();
      var test = function test(str) {
        return query.length ? str.indexOf(query) > -1 : true;
      };
      // 用于显示无搜索结果
      this.hasResult = false;

      var groupsInner = this.hasGroup ? this.data.map(function (group) {
        var matched = false;
        var children = group.children.map(function (item) {
          var show = test(item.label);
          matched = matched || show;
          return _this5.renderCheckboxItem(item, show);
        });
        _this5.hasResult = _this5.hasResult || matched;
        return h(
          'div',
          { 'class': 'selector__group', key: group.id, directives: [{
              name: 'show',
              value: matched
            }]
          },
          [h(
            'div',
            { 'class': 'selector__group-label' },
            [group.label]
          ), h(
            'div',
            { 'class': 'selector__group-list' },
            [children]
          )]
        );
      }) : h(
        'div',
        { 'class': 'selector__group no-label' },
        [h(
          'div',
          { 'class': 'selector__group-list' },
          [this.data.map(function (item) {
            var matched = test(item.label);
            _this5.hasResult = _this5.hasResult || matched;
            return _this5.renderCheckboxItem(item, matched);
          })]
        )]
      );

      return h(
        'el-checkbox-group',
        {
          attrs: { value: this.currentSelectedIds,

            min: this.min, max: this.max },
          on: {
            'input': function input(v) {
              _this5.currentSelectedIds = v;
            }
          }
        },
        [groupsInner]
      );
    },
    renderActions: function renderActions() {
      var h = this.$createElement;

      return h(
        'div',
        { 'class': 'selector__actions' },
        [this.defaultSelected && this.defaultSelected.length > 0 && h(
          'el-button',
          {
            attrs: { type: 'text' },
            on: {
              'click': this.resetDefault
            }
          },
          ['\u6062\u590D\u9ED8\u8BA4']
        ), h(
          'div',
          { 'class': 'selector__actions-right' },
          [this.showMaxLimit && h(
            'span',
            { 'class': 'limit-hint' },
            [this.maxHint ? this.maxHint : '\u6700\u591A\u9009\u62E9' + this.max + '\u9879']
          ), this.showMinLimit && h(
            'span',
            { 'class': 'limit-hint' },
            [this.minHint ? this.minHint : '\u6700\u5C11\u9009\u62E9' + this.min + '\u9879']
          ), h(
            'el-button',
            {
              attrs: { type: 'default' },
              on: {
                'click': this.close
              }
            },
            ['\u53D6\u6D88']
          ), h(
            'el-button',
            {
              attrs: { type: 'primary' },
              on: {
                'click': this.selectDone
              }
            },
            ['\u786E\u5B9A']
          )]
        )]
      );
    }
  },

  render: function render() {
    var _this6 = this;

    var h = arguments[0];

    return h(
      'div',
      { 'class': 'el-group-select', directives: [{
          name: 'clickoutside',
          value: this.close
        }]
      },
      [this.renderHeader(), h(
        'div',
        { 'class': 'selector__body', ref: 'body', style: { display: this.open ? 'block' : 'none' } },
        [this.filterable && h(
          'el-input',
          { 'class': 'filter-input',
            attrs: { value: this.filterInput,

              placeholder: this.filterPlaceholder },
            on: {
              'input': function input(v) {
                _this6.filterInput = v;
              }
            }
          },
          []
        ), this.max === MAX_VALUE && this.min === MIN_VALUE && this.renderShortcuts(), this.renderGroups(), !this.hasResult && this.filterable && h(
          'div',
          { 'class': 'filter-hint' },
          [this.filterNoResult]
        ), this.renderActions(), h(
          'div',
          { 'class': 'fixed__arrow' },
          []
        )]
      )]
    );
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/components/group-select/src/group-select.js
// module id = 296
// module chunks = 0